import { render } from "./SpecialtyDataFileDataForm.vue?vue&type=template&id=7876fae8&scoped=true&ts=true"
import script from "./SpecialtyDataFileDataForm.vue?vue&type=script&lang=ts"
export * from "./SpecialtyDataFileDataForm.vue?vue&type=script&lang=ts"

import "./SpecialtyDataFileDataForm.vue?vue&type=style&index=0&id=7876fae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7876fae8"]])

export default __exports__